import React, { useState, useEffect, useCallback } from 'react';
import api from '../../services/api';

// Drummond 2026 palette (CLAUDE.md). Series colours: fund navy, objective teal, peers slate.
export const C = {
  navy: '#012341', teal: '#337B91', slate: '#5E819C', tealDark: '#12706C', sage: '#A6C6C1',
  mauve: '#AA8090', lightBlue: '#BBCBD7', grey: '#3F4A59', greyMid: '#7F7F7F',
  warning: '#FBAE40', danger: '#F26B43', success: '#91CF9B', info: '#599BE3',
};
export const SERIES_COLOUR = {
  'Dynamic Plus Fund': C.navy, Objective: C.teal, 'FE AMI Flexible Peers': C.slate,
  'Global Equities': C.tealDark, 'Global Bonds': C.mauve, Cash: C.lightBlue,
};
export const AC_COLOURS = [C.navy, C.teal, C.tealDark, C.slate, C.sage, C.mauve, C.lightBlue, C.greyMid, C.warning, C.danger];
export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const isNum = (v) => typeof v === 'number' && Number.isFinite(v);
export const pct = (v, dp = 1, signed = false) => {
  if (!isNum(v)) return null;
  const s = (v * 100).toFixed(dp) + '%';
  return signed && v > 0 ? '+' + s : s;
};
export const num = (v, dp = 0) => (isNum(v) ? v.toLocaleString('en-AU', { minimumFractionDigits: dp, maximumFractionDigits: dp }) : null);
export const money = (v) => (isNum(v) ? 'A$' + (v / 1e6).toLocaleString('en-AU', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + 'm' : null);
export const Dash = () => <span className="pf-dash">–</span>;
export const V = ({ v, dp = 1, signed = false, kind = 'pct' }) => {
  const s = kind === 'pct' ? pct(v, dp, signed) : kind === 'money' ? money(v) : num(v, dp);
  return s === null ? <Dash /> : <>{s}</>;
};
export const signCls = (v) => (!isNum(v) || Math.abs(v) < 0.00005 ? '' : v > 0 ? 'pf-pos' : 'pf-neg');
export const tiltCls = (v, tol = 0.0005) => (!isNum(v) || Math.abs(v) < tol ? '' : v > 0 ? 'pf-tilt-over' : 'pf-tilt-under');
export const round10 = (v) => (isNum(v) ? Math.round(v / 10) * 10 : null);

export function useFetch(path, params, enabled = true) {
  const [state, setState] = useState({ data: null, error: null, loading: false });
  const key = JSON.stringify(params || {});
  const load = useCallback(() => {
    if (!enabled) return;
    setState((s) => ({ ...s, loading: true, error: null }));
    api.get(path, { params: params || {} })
      .then((r) => setState({ data: r.data, error: null, loading: false }))
      .catch((e) => setState({ data: null, error: e.response?.data?.detail || e.message, loading: false }));
  }, [path, key, enabled]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [load]);
  return { ...state, reload: load };
}

export const Status = ({ loading, error }) => (
  <>
    {loading && <div className="pf-muted">Loading…</div>}
    {error && <div className="pf-alert">{String(error)}</div>}
  </>
);

export const Tile = ({ label, value, sub, breach }) => (
  <div className={`pf-tile${breach ? ' pf-tile-breach' : ''}`}>
    <div className="pf-tile-label">{label}</div>
    <div className="pf-tile-value">{value ?? '–'}</div>
    {sub && <div className="pf-tile-sub">{sub}</div>}
  </div>
);
